module.exports = __webpack_public_path__ + "static/media/hotelPageSanitizationIcon.d7a93a35.png";